let lockCount = 0;

function applyLocked() {
  document.documentElement.style.overflow = "hidden";
  document.body.style.overflow = "hidden";
}

function applyUnlocked() {
  document.documentElement.style.overflow = "";
  document.body.style.overflow = "";
}

export function lockBodyScroll() {
  if (typeof document === "undefined") return;
  if (lockCount === 0) {
    applyLocked();
  }
  lockCount += 1;
}

export function unlockBodyScroll() {
  if (typeof document === "undefined") return;
  if (lockCount === 0) {
    // 防御热更新 / 异常路径留下的残留锁定
    applyUnlocked();
    return;
  }
  lockCount -= 1;
  if (lockCount === 0) {
    applyUnlocked();
  }
}

/** 强制恢复页面滚动（用于启动时或异常兜底） */
export function resetBodyScrollLock() {
  if (typeof document === "undefined") return;
  lockCount = 0;
  applyUnlocked();
}

/** 若当前没有弹窗占用锁，则清掉残留的 overflow 锁定 */
export function ensureBodyScrollUnlockedIfIdle() {
  if (typeof document === "undefined") return;
  if (lockCount === 0) {
    applyUnlocked();
  }
}
